import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { removeNgStyles, createNewHosts } from '@angularclass/hmr';

import { Ng2Webstorage } from 'ng2-webstorage';
import { ResponsiveModule } from 'ng2-responsive';
import { SlimLoadingBarService, SlimLoadingBarComponent } from 'ng2-slim-loading-bar';

import { AppComponent } from './app.component';
import { routing } from './app.routing';

import { SessionService } from './commons/session.service';
import { ConfigService } from './commons/config.service';
import { ScrollService } from './commons/scroll.service';
import { CartService } from './commons/cart.service';
import { WebsiteInterfaceService } from './commons/website-interface.service';
import { ConfiguratorApiService } from './commons/configurator-api.service';
import { TranslateService } from './commons/translate.service';
import { ResponsoveService } from './commons/responsive.service';
import { LoadingPanelService } from './commons/loading-panel.service';
import { BraintreePaymentService } from './commons/braintree-payment.service';
import { SafePipe } from './commons/safe.pipe';
import { TranslatePipe } from './commons/translate.pipe';
import { EuroCurrencyPipe } from './commons/euro-currency.pipe';
import { UtilitiesService } from './commons/utilities.service';
import { ConfiguratorComponent, ConfigControlComponent } from './configurator';
import { ImageCropperModule } from 'ng2-img-cropper';

import { Angulartics2, Angulartics2Module, Angulartics2GoogleAnalytics, Angulartics2Facebook } from 'angulartics2';
// import { Uploader } from 'angular2-http-file-upload';



import {
  UploadPhotoComponent, LoadProductComponent, OrderCompletedComponent, SelectProductsComponent, SelectDimensionsComponent,
  CartComponent, CheckoutComponent, CheckoutCampionarioComponent, CampionarioCompletedComponent, PageCropComponent,
  PreviewComponent,
  NoContentComponent,
  BtnToggleComponent,
  SimilFancyComponent,
  SlideParameterComponent
} from './pages';

@NgModule({
  declarations: [
    UploadPhotoComponent, LoadProductComponent, OrderCompletedComponent, SelectProductsComponent, SelectDimensionsComponent,
    CartComponent, CheckoutComponent, CheckoutCampionarioComponent, CampionarioCompletedComponent, PageCropComponent,
    PreviewComponent,
    NoContentComponent,
    BtnToggleComponent,
    SimilFancyComponent,
    AppComponent,
    SlimLoadingBarComponent,
    SafePipe, TranslatePipe, EuroCurrencyPipe,
    ConfiguratorComponent, ConfigControlComponent,
    SlideParameterComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    routing,
    Ng2Webstorage,
    ResponsiveModule,
    ImageCropperModule,
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics, Angulartics2Facebook])
  ],
  providers: [
    SessionService,
    ConfigService,
    ScrollService,
    CartService,
    UtilitiesService,
    WebsiteInterfaceService,
    ConfiguratorApiService,
    TranslateService,
    ResponsoveService,
    SlimLoadingBarService,
    LoadingPanelService,
    BraintreePaymentService,
    // Angulartics2,
    // Angulartics2GoogleAnalytics,
    // Angulartics2Facebook
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {
    // PageScrollConfig.defaultDuration = 300;
  }
  hmrOnInit(store) {
    ////console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts